import React from 'react'
import { createGlobalStyle } from 'styled-components'

import { FlashManager } from 'general/managers/flashs/FlashManager'
import { PopinsManager } from 'general/managers/popins/PopinsManager'

const GlobalStyle = createGlobalStyle`
  :root {
    background-color: transparent;
  }
`

/**
 * ### WidgetContainer ###
 *
 * The `WidgetContainer` is a special container for widgets, that are not pages.
 * To use it, it must be used as the main JSX component in a widget "page" component, instead of the `Page` component.
 */
export const WidgetContainer: TFCC = ({ children }) => (
  <>
    <GlobalStyle />
    {children}
    <div id="blocks">
      <div id="popinManager">
        <PopinsManager />
      </div>
      <div id="flashManager">
        <FlashManager />
      </div>
    </div>
  </>
)
